import { useMemo } from "react";
import { motion } from "framer-motion";

const REVEAL_INITIAL = { opacity: 0, y: 24 };
const REVEAL_IN_VIEW = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, amount: 0.2 };
const REVEAL_EASE = [0.2, 0.7, 0.1, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const transition = useMemo(() => ({ duration: 0.9, delay, ease: REVEAL_EASE }), [delay]);
  return (
    <motion.div
      initial={REVEAL_INITIAL}
      whileInView={REVEAL_IN_VIEW}
      viewport={REVEAL_VIEWPORT}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
